import { useEffect, useState } from 'react';
import ContentPreview from './ContentPreview';
import './index.scss';
import {
    IconTrashOutline
} from '../../icons/svgs';
import Utils from '../Helper/utils';
import manager from '../../Manager';

function Content({ slides, selectedSlide, selectedSlideIndex, deleteSlide, saveSlides, lessonTitle, setActionLessonActive, actionLessonActive }) {
    const [saveDisabled, setSaveDisabled] = useState('');

    const handleSaveSlides = () => {
        const slideData = slides.map((item) => {
            return item.toSaveData();
        });
        if (validateSlideBeforeSave(slideData)) {
            saveSlides(slideData);
            setActionLessonActive(false)
            window.jQuery('#tbcourse-modal-active-lesson').modal('show');
            window.jQuery('#tbcourse-modal-active-lesson').modal({
                backdrop: false
            });
            let activatedLesson = window.jQuery('#activatedLesson');
            if (!activatedLesson.prop('checked')) {
                activatedLesson.click();
            }
        }
    }

    useEffect(() => {
        if (actionLessonActive) {

        }
    }, [actionLessonActive]);

    const validateSlideBeforeSave = (slideData) => {
        let errCode = 0;
        let errMessage = "";
        const templateData = {
            TextTemplate: ["title", "description"],
            ImageTemplate: ["title", "description", "images"],
            AudioTemplate: ["title", "description", "platform", "audio", "duration"],
            VideoTemplate: ["title", "description", "platform", "url", "video", "thumbnails", "duration"],
            DocumentTemplate: ["title", "description", "attachment", "downloadable"],
            MultipleChoiceTemplate: ["esay", "answer"]
        };
        slideData.forEach((slide) => {
            const allowed = templateData[slide.type];
            if (allowed) {
                const filtered = Object.keys(slide.data)
                    .filter(key => allowed.includes(key))
                    .reduce((obj, key) => {
                        obj[key] = slide.data[key];
                        return obj;
                    }, {});
                slide.data = filtered;
            }

            if (slide.type === 'VideoTemplate') {
                // if platform=bunnynet from embed, convert duration in minute to seconds for slide.duration
                if (slide.data?.platform === 'bunnynet') {
                    if (slide.data?.duration > 0) {
                        slide.duration = slide.data.duration * 60;
                    } else {
                        slide.duration = manager.getTemplate('VideoTemplate').getDuration();
                    }
                }
            }

            if (slide.type === 'AudioTemplate') {
                // if platform=s3 upload from embed, convert duration in minute to seconds for slide.duration
                if (slide.data?.platform === 'amazon') {
                    if (slide.data?.duration > 0) {
                        slide.duration = slide.data.duration * 60;
                    } else {
                        slide.duration = manager.getTemplate('AudioTemplate').getDuration();
                    }
                }
            }

            if (slide.type === 'MultipleChoiceTemplate') {
                if (slide.data?.answer === undefined) {
                    errCode++;
                    errMessage = slide.name + ', must have answer';
                }
                if (errCode === 0) {
                    // console.log(slide.data?.answer);
                    let isAnyCorrectAnswer = slide.data?.answer.filter(item => item.correct === true || item.correct === 'true');
                    if (isAnyCorrectAnswer.length === 0) {
                        errCode++;
                        errMessage = slide.name + ', must have correct answer!';
                    }
                }
            }
        });

        if (errCode > 0) {
            Utils.showError(errMessage);
            return false;
        }
        return true;
    }
    const getSlideIndex = () => {
        let index = selectedSlideIndex ?? 0;//slides.indexOf(selectedSlide) ?? 0;
        if (slides.length === 0) {
            return 0;
        }
        if (index >= 0) {
            return index + 1;
        }
        return 0;
    }
    const handleDeleteSlide = () => {
        deleteSlide(selectedSlideIndex)
    }

    useEffect(() => {
        if (selectedSlide) {
            setSaveDisabled(selectedSlide.saveDisabled)
        }
    });

    return (
        <div className="tbcourse-content">
            <div className="tbcourse-header tbcourse-content-header">
                <div className="tbcourse-header-title">
                    Slide {getSlideIndex()} / {slides.length}
                </div>
                <div className="tbcourse-header-action">
                    {(selectedSlide?.canDelete() &&
                        <button type="button" className='btn btn-delete-slide mr-3' onClick={handleDeleteSlide} disabled={saveDisabled}>
                            <div className="center-vertical">
                                <span><IconTrashOutline /></span>
                            </div>
                        </button>
                    )}

                    <button type="button" className='btn btn-save-lesson px-3' onClick={handleSaveSlides} disabled={saveDisabled}> Save Change</button>
                </div>
            </div>
            <div className="tbcourse-body tbcourse-content-body">
                <ContentPreview slides={slides} selectedSlide={selectedSlide} selectedSlideIndex={selectedSlideIndex} lessonTitle={lessonTitle} />
            </div>

        </div>
    );
}

export default Content;
